import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/dscr-loans', label: 'DSCR Loans' },
    { path: '/dscr-loan-requirements', label: 'Requirements' },
    { path: '/best-dscr-lenders', label: 'Lenders' },
    { path: '/dscr-loan-rates', label: 'Rates' },
    { path: '/about', label: 'About' },
  ];

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled
            ? 'bg-white shadow-lg'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-3 group">
              <div className="flex items-center justify-center w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-700 rounded-xl shadow-lg group-hover:shadow-blue-500/50 transition-all">
                <i className="ri-home-smile-line text-2xl text-white"></i>
              </div>
              <div className="flex flex-col">
                <span className={`text-xl font-bold transition-colors ${
                  isScrolled ? 'text-slate-900' : 'text-white'
                }`}>
                  DSCR Loans
                </span>
                <span className={`text-xs font-medium transition-colors ${
                  isScrolled ? 'text-blue-600' : 'text-blue-300'
                }`}>
                  Investment Property Financing
                </span>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center space-x-1">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-2 rounded-lg font-semibold text-sm transition-all whitespace-nowrap ${
                    location.pathname === link.path
                      ? isScrolled
                        ? 'bg-blue-50 text-blue-600'
                        : 'bg-white/20 text-white backdrop-blur-sm'
                      : isScrolled
                      ? 'text-slate-700 hover:bg-slate-50 hover:text-blue-600'
                      : 'text-white/90 hover:bg-white/10 hover:text-white backdrop-blur-sm'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <Link
                to="/apply"
                className="ml-4 px-6 py-2.5 bg-gradient-to-r from-yellow-500 to-yellow-600 text-slate-900 rounded-lg font-bold text-sm hover:from-yellow-600 hover:to-yellow-700 transition-all shadow-lg hover:shadow-yellow-500/50 hover:scale-105 whitespace-nowrap"
              >
                <i className="ri-file-text-line mr-2"></i>
                Apply Now
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className={`lg:hidden p-2 rounded-lg transition-colors ${
                isScrolled
                  ? 'text-slate-900 hover:bg-slate-100'
                  : 'text-white hover:bg-white/10'
              }`}
              aria-label="Toggle menu"
            >
              <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden bg-white border-t border-slate-200 shadow-xl">
            <div className="px-4 py-4 space-y-2">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`block px-4 py-3 rounded-lg font-semibold text-sm transition-all ${
                    location.pathname === link.path
                      ? 'bg-blue-50 text-blue-600'
                      : 'text-slate-700 hover:bg-slate-50 hover:text-blue-600'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <Link
                to="/apply"
                onClick={() => setIsMenuOpen(false)}
                className="block px-4 py-3 bg-gradient-to-r from-yellow-500 to-yellow-600 text-slate-900 rounded-lg font-bold text-sm text-center hover:from-yellow-600 hover:to-yellow-700 transition-all shadow-lg whitespace-nowrap"
              >
                <i className="ri-file-text-line mr-2"></i>
                Apply Now
              </Link>
            </div>
          </div>
        )}
      </nav>
    </>
  );
}
